import { createSlice } from '@reduxjs/toolkit';
import { ISlideContent } from '../components/playground/a11yPowerpoint/types';

interface IPowerPointFile {
    file: any;
    name: string;
    s3FilePath: string;
}

interface IPresentationState {
    slideCount: number;
    slideContent: ISlideContent[];
    selectedVoice: string;
    powerpoint: IPowerPointFile | null;
    isAudioGenEnabled: boolean;
}

const initialState: IPresentationState = {
    slideCount: 0,
    slideContent: [],
    selectedVoice: 'alloy',
    powerpoint: null,
    isAudioGenEnabled: false
}

const presentationSlice = createSlice({
    name: 'presentation',
    initialState,
    reducers: {
        setSlideCount(state, action) {
            state.slideCount = action.payload;
        },
        setSlideContent(state, action) {
            state.slideContent = action.payload;
        },
        setSelectedVoice(state, action) {
            state.selectedVoice = action.payload;
        },
        setPowerPointFile(state, action) {
            state.powerpoint = action.payload;
        },
        setIsAudioGenEnabled(state, action) {
            state.isAudioGenEnabled = action.payload;
        },
        resetPresentationStates(state) {
            state.slideCount = initialState.slideCount;
            state.slideContent = initialState.slideContent;
            state.selectedVoice = initialState.selectedVoice;
            state.powerpoint = initialState.powerpoint;
            state.isAudioGenEnabled = initialState.isAudioGenEnabled;
        }
    }
});

export const {
    setSlideCount,
    setSlideContent,
    setSelectedVoice,
    setPowerPointFile,
    setIsAudioGenEnabled,
    resetPresentationStates } = presentationSlice.actions;
export default presentationSlice.reducer;